import { render, staticRenderFns } from "./SparsProductFamilies.vue?vue&type=template&id=8eb17c34"
import script from "./SparsProductFamilies.vue?vue&type=script&lang=js"
export * from "./SparsProductFamilies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports